module.exports = __webpack_public_path__ + "img/car-dummy.757cd33d.png";